import tokenData from '../../design-tokens/base-tokens.json';
export const MuiFab = {
    defaultProps: {
        disableFocusRipple: true,
        disableRipple: true
    },
    styleOverrides: {
        root: ({ theme }) => ({
            textTransform: 'none',
            minHeight: 'unset',
            width: 'unset',
            '&:hover': {
                background: tokenData.tokens.palette.blue.blue600
            },
            '&.Mui-focusVisible': {
                background: tokenData.tokens.palette.blue.blue600,
                boxShadow: 'none',
                outline: '2px solid #000',
                outlineOffset: '2px'
            },
            '&:active': {
                background: tokenData.tokens.palette.blue.blue700
            },
            '&.Mui-disabled': {
                background: tokenData.tokens.palette.grey.disabled,
                color: tokenData.tokens.palette.background.white,
                cursor: 'not-allowed',
                pointerEvents: 'unset',
                '&:active': {
                    pointerEvents: 'none'
                }
            },
            '&.MuiFab-sizeSmall': {
                fontSize: 14,
                width: 24,
                height: 24,
                borderRadius: 20,
                ...theme.typography.labelSm
            },
            '&.MuiFab-sizeMedium': {
                fontSize: 16,
                width: 28,
                height: 28,
                borderRadius: 24,
                ...theme.typography.label
            },
            '&.MuiFab-sizeLarge': {
                fontSize: 20,
                width: 32,
                height: 32,
                borderRadius: 28,
                ...theme.typography.button
            }
        }),
        extended: ({ theme }) => ({
            '&.MuiFab-sizeSmall': {
                padding: theme.spacing(2, 6),
                width: 'unset',
                height: 24,
                borderRadius: 20,
                ...theme.typography.labelSm
            },
            '&.MuiFab-sizeMedium': {
                padding: theme.spacing(2, 6),
                width: 'unset',
                height: 28,
                borderRadius: 24,
                ...theme.typography.label
            },
            '&.MuiFab-sizeLarge': {
                textTransform: 'none',
                padding: theme.spacing(3, 6),
                width: 'unset',
                height: 32,
                borderRadius: 28,
                ...theme.typography.labelLg
            },
            '.MuiSvgIcon-root': {
                marginRight: theme.spacing(2)
            }
        })
    }
};
